module.exports = __webpack_public_path__ + "static/media/bannertienda.c4e3cbe7.png";